import * as Core from "@govflanders/vl-ui-core";
import svg4everybody from "svg4everybody";
import Accordion from "@govflanders/vl-ui-accordion";
import Equalheight from "@govflanders/vl-ui-equal-height";
import Slider from '@govflanders/vl-ui-slider';
import FunctionalHeader from "../components/functionalHeader";
import TopHeader from "../components/topHeader";
import PersonasNavigation from "../components/personasNavigation";
import InputClear from "../components/inputClear";
import HelpDropdown from "../components/helpDropdown";
import CookieAccept from "../components/cookieAccept";
import FileUploadFocus from "../components/fileUploadFocus";
import UploadButtonsToggle from "../components/uploadButtonsToggle";

export const componentLoader = {
  page: null,
  checkInitializedPage: function() {
    this.enableDefaultComponents();
    switch (this.page) {
      case "index":
        break;
      default:
        console.info("only default components");
    }
  },
  enableDefaultComponents: function() {
    new FunctionalHeader(document.querySelector(".br-functional-header"));
    new TopHeader(document.querySelector(".br_top-header"));
    new PersonasNavigation(document.querySelector(".br_personas-navigation"));
    new InputClear(document.querySelectorAll(".br_search-input"));
    new HelpDropdown();
		new CookieAccept(document.querySelector(".br_cookie-banner"));
		new FileUploadFocus(document.querySelectorAll('.ktc-file-component-wrapper'));
		new UploadButtonsToggle();
		svg4everybody();
  }
};
